import React from 'react';
import { MessageCircle, Mail, MapPin, Clock } from 'lucide-react';

const ContactPage: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-4xl font-bold text-slate-800 mb-4" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
        Contact Us
      </h1>
      <p className="text-lg text-slate-600 mb-10">
        We're here to help. Get in touch via your preferred channel.
      </p>

      <div className="grid md:grid-cols-2 gap-6 mb-12">
        <a
          href="https://wa.me/27646386983"
          className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 hover:shadow-xl transition-shadow flex items-start gap-4 group"
        >
          <div className="w-14 h-14 bg-green-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
            <MessageCircle size={28} className="text-green-600" />
          </div>
          <div>
            <h3 className="font-bold text-slate-800 mb-1">WhatsApp</h3>
            <p className="text-sm text-slate-500">+27 64 638 6983</p>
            <p className="text-xs text-slate-400 mt-1">Fastest response — typically within 2 hours</p>
          </div>
        </a>

        <a
          href="mailto:hello@chrysalinks-group.co.za"
          className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 hover:shadow-xl transition-shadow flex items-start gap-4 group"
        >
          <div className="w-14 h-14 bg-blue-100 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform">
            <Mail size={28} className="text-blue-600" />
          </div>
          <div>
            <h3 className="font-bold text-slate-800 mb-1">Email</h3>
            <p className="text-sm text-slate-500">hello@chrysalinks-group.co.za</p>
            <p className="text-xs text-slate-400 mt-1">We reply within 24 hours</p>
          </div>
        </a>

        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 flex items-start gap-4">
          <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <MapPin size={28} className="text-purple-600" />
          </div>
          <div>
            <h3 className="font-bold text-slate-800 mb-1">Location</h3>
            <p className="text-sm text-slate-500">Cape Town, South Africa</p>
            <p className="text-xs text-slate-400 mt-1">Fully remote — serving SA nationwide</p>
          </div>
        </div>

        <div className="bg-white rounded-2xl shadow-lg p-6 border border-slate-100 flex items-start gap-4">
          <div className="w-14 h-14 bg-amber-100 rounded-xl flex items-center justify-center flex-shrink-0">
            <Clock size={28} className="text-amber-600" />
          </div>
          <div>
            <h3 className="font-bold text-slate-800 mb-1">Business Hours</h3>
            <p className="text-sm text-slate-500">Mon–Fri: 8:00 AM – 6:00 PM</p>
            <p className="text-sm text-slate-500">Sat: 9:00 AM – 2:00 PM</p>
            <p className="text-xs text-slate-400 mt-1">SAST (UTC+2)</p>
          </div>
        </div>
      </div>

      {/* Quick Contact Form */}
      <div className="bg-white rounded-2xl shadow-lg p-8 border border-slate-100">
        <h2 className="text-2xl font-bold text-slate-800 mb-6" style={{ fontFamily: "'Fairplay Display', Georgia, serif" }}>
          Send Us a Message
        </h2>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            const form = e.target as HTMLFormElement;
            const name = (form.elements.namedItem('name') as HTMLInputElement).value;
            const email = (form.elements.namedItem('email') as HTMLInputElement).value;
            const message = (form.elements.namedItem('message') as HTMLTextAreaElement).value;
            window.location.href = `mailto:hello@chrysalinks-group.co.za?subject=Contact from ${encodeURIComponent(name)}&body=${encodeURIComponent(`From: ${name} (${email})\n\n${message}`)}`;
          }}
          className="space-y-4"
        >
          <div className="grid md:grid-cols-2 gap-4">
            <input
              type="text"
              name="name"
              placeholder="Your Name"
              required
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#4a6580] focus:ring-2 focus:ring-[#4a6580]/20 outline-none transition-all"
            />
            <input
              type="email"
              name="email"
              placeholder="Your Email"
              required
              className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#4a6580] focus:ring-2 focus:ring-[#4a6580]/20 outline-none transition-all"
            />
          </div>
          <textarea
            name="message"
            placeholder="How can we help?"
            rows={5}
            required
            className="w-full px-4 py-3 rounded-xl border border-slate-200 focus:border-[#4a6580] focus:ring-2 focus:ring-[#4a6580]/20 outline-none transition-all resize-none"
          />
          <button
            type="submit"
            className="bg-[#4a6580] hover:bg-[#3a5468] text-white font-semibold px-8 py-3 rounded-xl transition-all active:scale-[0.98]"
          >
            Send Message
          </button>
        </form>
      </div>
    </div>
  );
};

export default ContactPage;
